/** cond 国家分组 key（X 渠道使用 common 桶） */
export const X_HASHTAG_COND_SOURCE = 'channel_x';

/** localStorage：上次国家筛选（快捷区 + 自定义） */
export const X_HASHTAG_STORAGE_PREFIX = 'marketing_hashtag_x_custom_countries';

export const BURIED_CHANNEL = 'twitter';

export type TCountryMode = 'quick' | 'custom';

/** UI 维度 ↔ API group_by */
export type TXDimension = 'country' | 'date';

export interface IQuickRegionOption {
  key: string;
  label: string;
  countryCodes: string[];
}

export const QUICK_REGION_OPTIONS: IQuickRegionOption[] = [
  {
    key: 'japan_korea',
    label: 'Japan & Korea',
    countryCodes: ['jp', 'kr'],
  },
  {
    key: 'north_america',
    label: 'North America',
    countryCodes: ['ca', 'us', 'mx'],
  },
  {
    key: 'southeast_asia',
    label: 'Southeast Asia',
    countryCodes: ['id', 'my', 'ph', 'sg', 'vn'],
  },
];

/** 默认选中：日韩 + 北美 */
export const DEFAULT_QUICK_KEYS = ['japan_korea', 'north_america'];

export function getCountriesFromQuickKeys(keys: string[]): string[] {
  const set = new Set<string>();
  QUICK_REGION_OPTIONS.forEach(option => {
    if (keys.includes(option.key)) {
      option.countryCodes.forEach(code => set.add(code));
    }
  });
  return Array.from(set);
}

export const DEFAULT_COUNTRIES = getCountriesFromQuickKeys(DEFAULT_QUICK_KEYS);
